const metaData = {
  id: "",
  name: "",
  description: "",
};

const gridLevels = ["__grid_id_5", "__grid_id_8", "__grid_id_10", "__grid_id"];

export default function() {
  return {
    isTempWidgets: false,
    isInitialized: false,
    isPublicView: false,
    isFiltersEditable: false,
    isLayersEditable: false,
    isConfigsEditable: false,
    isFiltersVisible: true,
    activeGridLevel: 3,
    gridLevels,
    ...metaData,
  };
}
